import { WindowsTop } from './top/WindowsTop'
import { WindowsFront } from './front/WindowsFront'
import { WindowsSide } from './side/tie/WindowsSide'

export const Windows = () => {

  return (
    <>
      <WindowsFront />
      <WindowsTop />
      <WindowsSide />
    </>
  )
}
